class SizeChart extends HTMLElement {
    constructor() {
        super();

        // Event listener setups
        this.setupEventListeners();
    }

    setupEventListeners() {
        document.querySelectorAll('[data-open-sizechart-popup]').forEach(button =>
            button.addEventListener('click', this.setOpenPopup.bind(this))
        );

        document.querySelector('[data-close-sizechart-popup]')?.addEventListener(
            'click', this.setClosePopup.bind(this)
        );

        document.querySelectorAll('[data-open-sizechart-sidebar]').forEach(button =>
            button.addEventListener('click', this.setOpenSidebar.bind(this))
        );

        document.querySelector('[data-close-sizechart-sidebar]')?.addEventListener(
            'click', this.setCloseSidebar.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    setOpenPopup(event) {
        event.preventDefault();
        document.body.classList.add('sizechart-popup-show');
    }

    setClosePopup(event) {
        event.preventDefault();
        document.body.classList.remove('sizechart-popup-show');
    }

    setOpenSidebar(event) {
        event.preventDefault();

        /* Read product handle from the trigger. Defaults to the page's
           main product (whose handle is baked into the sidebar element
           via data-default-product-handle). This lets any trigger on the
           page open the sidebar showing a SPECIFIC product's size chart
           — used by the Make-It-A-Set partner cards which point at the
           partner product, not the page's main product. */
        const trigger = event.currentTarget;
        const productHandle =
            (trigger && trigger.dataset && trigger.dataset.productHandle) ||
            this.dataset.defaultProductHandle;

        if (productHandle) {
            /* Show only the chart container for this product; hide the rest.
               Each container has [data-chart-product="{handle}"]. */
            this.querySelectorAll('[data-chart-product]').forEach(wrapper => {
                wrapper.hidden = (wrapper.dataset.chartProduct !== productHandle);
            });
        }

        document.body.classList.add('sizechart-sidebar-show');
    }

    setCloseSidebar(event) {
        event.preventDefault();
        document.body.classList.remove('sizechart-sidebar-show');
    }

    onBodyClickEvent(event) {
        if (!this.contains(event.target)) {
            if (document.body.classList.contains('sizechart-popup-show') && !event.target.closest('[data-open-sizechart-popup]')) {
                this.setClosePopup(event);
            }
            if (document.body.classList.contains('sizechart-sidebar-show') && !event.target.closest('[data-open-sizechart-sidebar]')) {
                this.setCloseSidebar(event);
            }
        }
    }
}

customElements.define('size-chart', SizeChart);
